module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_6.8ec51142.png";